import React, {useCallback} from "react";
import {useDispatch, useSelector} from "react-redux";
import {CardComponent, OptionsComponent} from "../../../components";
import {HMDA_INFO_SAVE_ACTION, SET_NEXT_PAGE} from "../../../redux/actions";

const HMDARaceInfo = () => {
  const dispatch = useDispatch();
  const navigateNext = useCallback((state, edit, applicant) => dispatch(SET_NEXT_PAGE(state, edit, applicant)), [dispatch]);
  const saveHMDAInfo = useCallback((value) => dispatch(HMDA_INFO_SAVE_ACTION(value)), [dispatch]);

  const applicants = useSelector( state => state.wizardStore.model.applicants);
  const currentApplicant = useSelector( state => state.wizardStore.meta.currentApplicant);
  const hmdaRace = useSelector( state => state.wizardStore.meta.hmdaRace);
  const applicantIndex = parseInt(currentApplicant.toString());
  const applicant = applicants[applicantIndex];

  const _clickHandler = (key, value) => {
    saveHMDAInfo({race: value});
    navigateNext("hmda_summary", false, applicantIndex);
  };

  return (
    <CardComponent title={`What is ${applicant.firstName}'s race?`}>
      <p className="cp-font-r18w400g500 mb-1 md:mb-4 text-justify">
        The following questions are not required but you may choose to share the information for statistical purposes.
      </p>
      <OptionsComponent onClick={_clickHandler} options={hmdaRace} />
    </CardComponent>
  );
};

export default HMDARaceInfo;
